export default __webpack_public_path__ + "static/media/sap.ad5e13e1.png";